import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguageFromStorage } from 'syf-js-utilities';
import englishTranslations from './lang/en';
import spanishTranslations from './lang/es';
const translations = {
    en: englishTranslations,
    es: spanishTranslations
};
const i18n = createInstance({
    fallbackLng: 'en', // use en if detected lng is not available
    lng: getLanguageFromStorage(),
    interpolation: {
        escapeValue: false // react already safe from xss
    },
    resources: translations,
    parseMissingKeyHandler: () => ''
});
i18n.use(LanguageDetector).use(initReactI18next).init();
export default i18n;
